var escapeRegExp = function(strToEscape) {
  // Escape special characters for use in a regular expression
  return strToEscape.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
};

window.strip_tags = function (s) {
  var temp = document.createElement("div");
  temp.innerHTML = s;
  var res = temp.textContent || temp.innerText || '';
  res.replace('\u200B', ''); // zero width space
  res = res.trim();
  return res;
};

if (!String.prototype.rtrim) {
  String.prototype.rtrim = function rtrim(char) {
    char = escapeRegExp(char);
    var regEx = new RegExp("[" + char + "]+$", "g");
    return this.replace(regEx, "");
  };
}

if (!String.prototype.ltrim) {
  String.prototype.ltrim = function ltrim(char) {
    char = escapeRegExp(char);
    var regEx = new RegExp("^[" + char + "]+", "g");
    return this.replace(regEx, "");
  };
}

export function event_hit(evt, target) {
  if (!target) {
    return true;
  }
  if (evt.path) {
    return evt.path.includes(target);
  }
  if (evt.composedPath) {
    return evt.composedPath().includes(target);
  }
  return true;
}


// WEBPACK FOOTER //
// ./src/helpers/util.js